import { useFrame, useThree } from "@react-three/fiber";
import { Color, MathUtils } from "three";
import { Instances, Instance, useTexture, Billboard, Points, Point } from "@react-three/drei";
import { useEffect, useMemo, useRef } from "react";
import steamTexturePath from "./star_05.png";

import * as THREE from "three";
import { Vector3 } from "three";
import { useState } from "react";

// export const SteamParticelsBAS = ({ ...props }) => {
//   const groupRef = useRef();

//   useMemo(() => {}, []);

//   return <group {...props} ref={groupRef}></group>;
// };

const SparkParticlesInstances = ({
  particleCount = 50,
  lifetime = 5,
  active,
  rotationSpeed = 0,
  // XWIDTH = 6,
  // ZWIDTH = 15,
  // HEIGHT = 25,
  ...props
}) => {
  const ref = useRef();
  const groupRef = useRef();
  const { clock } = useThree();

  // const [startTime, setstartTime] = useState(0);
  // const [stopTime, setstopTime] = useState(0);
  const startTime = useRef(0);
  const stopTime = useRef(0);

  const [_active, _setActive] = useState(false);

  useEffect(() => {
    if (active) {
      startTime.current = clock.elapsedTime;
      _setActive(true);
      // console.log("START");
      // setstartTime(clock.elapsedTime);
    } else {
      stopTime.current = clock.elapsedTime;
      _setActive(false);
      // console.log("STOP");
      // setstopTime(clock.elapsedTime);
    }
  }, [active]);

  const steamTexture = useTexture(steamTexturePath);

  const particles = useMemo(() => {
    return Array.from({ length: particleCount }, () => ({
      factor: MathUtils.randInt(20, 100),
      speed: MathUtils.randFloat(0.05, 0.1),
      delay: MathUtils.randFloat(0.1, lifetime - 0.1),
      direction: new Vector3(
        MathUtils.randFloat(-0.05, 0.025),
        MathUtils.randFloat(0.01, 0.08),
        MathUtils.randFloat(-0.025, 0.025),
      ),
      scale: 0.021,
      // speed: MathUtils.randFloat(10, 10000),
      // xFactor: MathUtils.randFloatSpread(XWIDTH),
      // yFactor: MathUtils.randFloatSpread(HEIGHT) + 10,
      // zFactor: MathUtils.randFloatSpread(ZWIDTH),
    }));
  }, []);

  useFrame(() => {
    groupRef.current.rotation.y += rotationSpeed;
  });

  return (
    <group {...props} ref={groupRef}>
      <Points limit={particles.length} ref={ref} castShadow receiveShadow position={[0, 0, 0]}>
        {/* <sphereGeometry args={[1, 32, 32]} /> */}
        {/* <cylinderBufferGeometry args={[0.0075, 0.0075, 0.2, 3]} /> */}
        {/* <planeGeometry args={[0.3, 0.3, 1, 1]} /> */}
        <pointsMaterial
          color={new Color(25, 5, 1)}
          // blending={THREE.AdditiveBlending}
          transparent
          depthTest={true}
          depthWrite={false}
          map={steamTexture}
          // alphaMap={steamTexture}
          opacity={1}
          size={0.0051}
        />
        {/* <meshBasicMaterial
          color="#f0f0f0"
          transparent
          opacity={0.8}
          blending={THREE.AdditiveBlending}
          map={steamTexture}
          depthTest={true}
          depthWrite={false}
          side={THREE.DoubleSide}
        /> */}
        {particles.map((data, i) => (
          <SteamParticle key={i} {...data} lifetime={lifetime} startTime={startTime} stopTime={stopTime} active={_active} />
        ))}
      </Points>
    </group>
  );
};

const gravity = new Vector3(0, -9.81, 0);

const SteamParticle = ({ delay, lifetime, speed, direction, startTime, stopTime, active, scale }) => {
  const ref = useRef();

  const currentProgress = useRef(1);

  const randomRotation = useMemo(() => {
    return [
      MathUtils.degToRad(MathUtils.randFloat(0, 360)),
      MathUtils.degToRad(MathUtils.randFloat(0, 360)),
      MathUtils.degToRad(MathUtils.randFloat(0, 360)),
    ];
  }, []);

  useFrame(({ clock }) => {
    let progress = ((clock.elapsedTime - (startTime.current + delay)) % lifetime) / lifetime;

    if (active) {
      // currentProgress.current = Math.max(progress, currentProgress.current);
      currentProgress.current = Math.max(progress, 0);
    } else {
      currentProgress.current = Math.max(progress, currentProgress.current);
    }

    // console.log(ref.current);

    // ref.current.scale.set(scale, scale, scale);

    ref.current.color.r = 1 - currentProgress.current;
    ref.current.color.g = 1 - currentProgress.current;
    ref.current.color.b = 1 - currentProgress.current;

    ref.current.position.set(
      direction.x * currentProgress.current,
      direction.y * currentProgress.current,
      direction.z * currentProgress.current,
    );
  });

  return (
    // <Billboard>
    <Point
      ref={ref}
      position={[0, 0, 0]}
      // rotation={randomRotation}
      scale={0}
    />
    // </Billboard>
  );
};

export default SparkParticlesInstances;
